import { getMessages } from '../../../../../../store/constants';

export const COPY_LINK_TITLE = getMessages().getText('copy_link.title');
export const COPY_LINK_BODY = getMessages().getText('copy_link.body');
export const COPY_LINK_CLOSE = getMessages().getText('copy_link.close');
